import * as React from "react"

import { cn } from "../../lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border-2 border-neutral300 dark:border-neutral600 bg-white dark:bg-neutral800 px-4 py-2 text-sm text-neutral900 dark:text-neutral100 transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-neutral400 dark:placeholder:text-neutral500 focus-visible:outline-none focus-visible:border-sumoPrimary focus-visible:ring-4 focus-visible:ring-sumoPrimary/10 disabled:cursor-not-allowed disabled:bg-neutral100 dark:disabled:bg-neutral700 disabled:opacity-60 hover:border-neutral400 dark:hover:border-neutral500",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
